const url = 'situacoes-avaliacoes-metas';
class SituacaoAvaliacaoMetaService {
    async list() {
        const response = await window.$http.get(`${url}`);
        return response.data;
    }
}

export default new SituacaoAvaliacaoMetaService();
